import React from "react";
import { useTranslation } from "react-i18next";

import Button from "~/shared/ui/Fields/Button";

import s from "./styles.less";

type Props = {
  onAgree: () => void;
  onDisagree: () => void;
};

export const AgreementPage = ({ onAgree, onDisagree }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={s.page}>
      <div className={s.card}>
        <div className={s.title}>{t("ui.attention")}</div>
        <div className={s.body}>
          <div>{t("ui.information_contains")}</div>
          <br />
          <div>{t("ui.according_to_law")}</div>
          <br />
          <div>{t("ui.material_responsibility")}</div>
          <br />
          <div>{t("ui.are_agree_to_continue")}</div>
        </div>
        <div className={s.actions}>
          <Button txtBtn={t("ui.not_agree")} empty onClick={onDisagree} />
          <Button txtBtn={t("ui.agree")} onClick={onAgree} />
        </div>
      </div>
    </div>
  );
};

export default AgreementPage;
